import { render } from "./DocumentComposition.vue?vue&type=template&id=9a575ae8"
import script from "./DocumentComposition.vue?vue&type=script&lang=js"
export * from "./DocumentComposition.vue?vue&type=script&lang=js"

import "./DocumentComposition.vue?vue&type=style&index=0&id=9a575ae8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__